import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from './service/routing.service';
import { ConfigService } from './service/config.service';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { ConnectionService } from 'ng-connection-service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  theme: string;
  isOnline: boolean;
  baseUrl: string;

  constructor(
    private route: ActivatedRoute,
    public routing: RoutingService,
    private translate: TranslateService,
    private updates: SwUpdate,
    private connectionService: ConnectionService,
    public dialog: MatDialog,
    public config: ConfigService,
  ) {
    this.updates.versionUpdates.subscribe((event: VersionEvent) => {
      if (event.type === 'VERSION_READY') {
        this.updates.activateUpdate().then(() => document.location.reload());
      }
    });

    translate.setDefaultLang('en');

    routing.getTitle();

    this.route.queryParams.subscribe((params) => {
      const theme =
        params.theme ||
        (this.config.appConfig.setup.useStorage &&
          localStorage.getItem('theme')) ||
        this.config.appConfig.routing.theme;

      this.routing.inTheme(theme);
      this.theme = this.routing.theme;
      if (params.i18n) {
        this.translate.use(params.i18n);
      }
    });
  }
}
